import axios from "axios";
import GetServerAddress from "../../functions/GetServerAddress";

export function Get_All_Attendees_From_Array(
  dbName,
  collctiontext,
  prop,
  array,
  fields,
  setdata,
  logout
) {
  const fetchData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() +
          "api/consultant/Get_All_Attendees_From_Array",
        {
          dbName: dbName,
          collctiontext: collctiontext,
          prop: prop,
          array: array,
          fields: fields,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("ConsultantToken")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Consultant_id"),
            activitylog: "No",
          },
        }
      );
      console.log("Response Data: ", response);

      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logout();
        console.log("FAILED");
        return; // Stop further execution in case of invalid auth token
      }
      //Check if nothing found
      if (response.data.data.length === 0) {
        return;
      }
      //handle data set
      setdata(response.data.data); // Update your state with the fetched data
      //Catch Errors
    } catch (error) {
      console.error("Error fetching data: ", error);
      window.alert(
        "Error Getting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };
  //Run
  fetchData();
}
